import script from "./ChartBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartBar.vue?vue&type=script&setup=true&lang=js"

import "./ChartBar.vue?vue&type=style&index=0&id=2c32b1a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c32b1a8"]])

export default __exports__